module.exports = __webpack_public_path__ + "img/bidFail.b78027c3.png";